import { render, staticRenderFns } from "./submenu-item.vue?vue&type=template&id=68a0e872&scoped=true&"
import script from "./submenu-item.vue?vue&type=script&lang=ts&"
export * from "./submenu-item.vue?vue&type=script&lang=ts&"
import style0 from "./submenu-item.vue?vue&type=style&index=0&id=68a0e872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0e872",
  null
  
)

export default component.exports